import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { User } from '@unleashed/models/account';
import { AuthorizationService } from '@unleashed/services/account';
import { NavigationSteps } from '@unleashed/models/booking';
import { BookingSessionService } from '@unleashed/services/booking';

@Component({
  selector: 'ua-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.scss']
})
export class AccountInfoComponent implements OnInit {

  faPencilAlt = faPencilAlt;

  user?: User;
  edit = false;
  step?: string;

  constructor(
    private authService: AuthorizationService,
    private sessionService: BookingSessionService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    const slug = this.route.snapshot.queryParamMap.get('park');
    this.step = this.route.snapshot.queryParamMap.get('step') ?? undefined;
    this.edit = (this.route.snapshot.queryParamMap.get('edit') ?? '') === 'true';

    if (slug) {
      this.sessionService.setParkBySlug(slug);
    }

    this.authService.getUser()
      .subscribe(user => {
        if (!user.loggedIn) {
          this.sessionService.navigateToLogin();
        }
        this.user = user;
      });
  }

  toggleEdit(): void {
    this.edit = !this.edit;
  }

  cancel(): void {
    if (this.step) {
      this.sessionService.navigateToStep(NavigationSteps.Start);
      return;
    }
    this.toggleEdit();
  }

  save(): void {
    if (this.step) {
      const key = Object.keys(NavigationSteps).find(ns => ns.toLowerCase() === this.step?.toLowerCase());
      const navStep = NavigationSteps[key as keyof typeof NavigationSteps];
      this.sessionService.navigateToStep(navStep);
      return;
    }
    this.toggleEdit();
  }

}
